import { TreeValue } from "./TreeSelect";

type TreeSelectAction =
  | { type: "SEARCH_PROJECT"; name: string }
  | {
      type: "SET_CURRENT_VALUES";
      currentValues: TreeValue;
    };

interface TreeBranch {
  id: string;
  label: string;
  branches?: Array<TreeBranch>;
  disabled: boolean;
  show: boolean;
}

type TreeState = {
  listMeta: Array<TreeBranch>;
  currentValues: TreeValue;
};

const searchInTree = (branch: TreeBranch, text: string) => {
  if (branch.branches?.length === 0) {
    if (branch.label.toLowerCase().includes(text.toLowerCase())) {
      branch.show = true;
      return true;
    } else {
      branch.show = false;
      return false;
    }
  } else {
    let exist = false;
    branch.branches?.forEach((elem) => {
      if (searchInTree(elem, text)) {
        exist = true;
      }
    });
    if (exist || branch.label.toLowerCase().includes(text.toLowerCase())) {
      branch.show = true;
    }
    return exist || branch.label.toLowerCase().includes(text.toLowerCase());
  }
};

const searchByText = (newList: Array<TreeBranch>, text: string) => {
  newList.forEach((branch: TreeBranch) => {
    if (searchInTree(branch, text)) {
      branch.show = true;
    } else {
      branch.show = false;
    }
  });
  return newList;
};

function TreeSelectReducer(state: TreeState, action: TreeSelectAction): TreeState {
  switch (action.type) {
    case "SEARCH_PROJECT":
      return {
        ...state,
        listMeta: searchByText(state.listMeta, action.name),
      };

    case "SET_CURRENT_VALUES":
      return {
        ...state,
        currentValues: action.currentValues,
      };

    default:
      return {
        ...state,
      };
  }
}

export { TreeSelectAction, TreeSelectReducer, TreeState };
